/*eslint no-unused-vars: ["error", {"args": "none"}]*/

const state = {
  level: 1, //starting with stepper level 1
  ssid: "",
  password: "",
  protocoll: "",
  token: "",
  verify_email: "",
  verify_password: "",
  selectedCountryCode: "DE",
  country_code_list: [
    { name: "Austria", code: "AT" },
    { name: "Belgium", code: "BE" },
    { name: "Bulgaria", code: "BG" },
    { name: "Croatia", code: "HR" },
    { name: "Czech Republic", code: "CZ" },
    { name: "Cyprus", code: "CY" },
    { name: "Denmark", code: "DK" },
    { name: "Estonia", code: "EE" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "Germany", code: "DE" },
    { name: "Greece", code: "GR" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "Ireland", code: "IE" },
    { name: "Italy", code: "IT" },
    { name: "Latvia", code: "LV" },
    { name: "Lithuania", code: "LT" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Luxembourg", code: "LU" },
    { name: "Malta", code: "MT" },
    { name: "Norway", code: "NO" },
    { name: "Netherlands", code: "NL" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Romania", code: "RO" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Spain", code: "ES" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Turkey", code: "TR" },
  ],
};

const actions = {
  incrementLevel(context) {
    context.commit("setLevel", context.state.level + 1);
  },
  resetLevel(context) {
    context.commit("setLevel", 1);
  },
  resetData({ state }) {
    state.ssid = "";
    state.password = "";
    state.protocoll = "";
    state.token = "";
    state.verify_email = "";
    state.verify_password = "";
  },
  setSSID({ context, state }, ssid) {
    state.ssid = ssid;
  },
  setPassword({ context, state }, password) {
    state.password = password;
  },
  setProtocoll({ context, state }, protocoll) {
    state.protocoll = protocoll;
  },
  setToken({ context, state }, token) {
    state.token = token;
  },
  setVerifyEmail({ context, state }, email) {
    state.verify_email = email;
  },
  setVerifyPassword({ context, state }, password) {
    state.verify_password = password;
  },
  setCountryCode({ state }, code) {
    state.selectedCountryCode = code;
  },
};

const mutations = {
  setLevel(state, level) {
    state.level = level;
  },
};

const getters = {
  currentLevel(state) {
    return state.level;
  },
  getToken(state) {
    return state.token;
  },
  getSSID(state) {
    return state.ssid;
  },
  getPassword(state) {
    return state.password;
  },
  getProtocoll(state) {
    return state.protocoll;
  },
  getVerifyEmail(state) {
    return state.verify_email;
  },
  getVerifyPassword(state) {
    return state.verify_password;
  },
  getCountryCode(state) {
    return state.selectedCountryCode;
  },
  getCountryList(state) {
    return state.country_code_list;
  },
};

export const onboarding = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
